/**
 * Combined Shipping + Gift Threshold Progress Bar
 * Displays dual milestones: Free Shipping ($99) and Free Gift ($300)
 */
(() => {
  'use strict';

  console.log('[CombinedProgress] Combined threshold progress bar script loaded');

  // Hardcoded thresholds for shipping and gift
  const SHIPPING_THRESHOLD = 99; // $99 in dollars
  const GIFT_THRESHOLD = 300; // $300 in dollars

  const updateCombinedProgressBar = () => {
    const progressContainer = document.querySelector('[data-combined-threshold-progress]');
    console.log('[CombinedProgress] Update called, container found:', !!progressContainer);

    if (!progressContainer) {
      console.log('[CombinedProgress] Progress container not found in DOM');
      return;
    }

    // Check if gift threshold system is enabled and progress bar should be shown
    if (window.GiftThresholdManager) {
      const config = window.GiftThresholdManager.getConfig();

      // Hide progress bar if gift threshold is disabled or progress bar is explicitly hidden
      if (!config.enabled || config.showProgressBar === false) {
        console.log('[CombinedProgress] Progress bar hidden (enabled:', config.enabled, ', showProgressBar:', config.showProgressBar, ')');
        progressContainer.style.display = 'none';
        return;
      }
    }

    // Fetch current cart
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (!cart) {
          console.log('[CombinedProgress] No cart data');
          progressContainer.style.display = 'none';
          return;
        }

        // Calculate cart total excluding any auto-added gifts
        let totalPrice = cart.total_price; // in cents

        // Exclude gift items from calculation (if GiftThresholdManager is available)
        if (window.GiftThresholdManager) {
          const config = window.GiftThresholdManager.getConfig();
          const giftPropertyKey = config.giftPropertyKey || '_auto_gift';
          const giftItems = cart.items.filter(item =>
            item.properties && item.properties[giftPropertyKey]
          );

          if (giftItems.length > 0) {
            const giftTotal = giftItems.reduce((sum, item) => sum + (item.final_line_price || 0), 0);
            totalPrice = cart.total_price - giftTotal;
            console.log('[CombinedProgress] Cart total (excluding gifts):', totalPrice / 100);
          }
        }

        const totalDollars = totalPrice / 100;

        // Get UI elements
        const textSpan = progressContainer.querySelector('.combined-threshold-progress__text');
        const progressBar = progressContainer.querySelector('.combined-threshold-progress__bar');
        const progressFill = progressContainer.querySelector('.combined-threshold-progress__fill');
        const shippingMilestone = progressContainer.querySelector('[data-milestone="shipping"]');
        const giftMilestone = progressContainer.querySelector('[data-milestone="gift"]');

        if (!textSpan || !progressBar || !progressFill || !shippingMilestone || !giftMilestone) {
          console.log('[CombinedProgress] Missing required elements');
          return;
        }

        // Calculate progress percentage (based on gift threshold as 100%)
        const progressPercent = Math.min(100, (totalDollars / GIFT_THRESHOLD) * 100);

        // Determine milestone states
        const shippingMet = totalDollars >= SHIPPING_THRESHOLD;
        const giftMet = totalDollars >= GIFT_THRESHOLD;

        // Update milestone classes
        shippingMilestone.className = 'milestone milestone--shipping';
        giftMilestone.className = 'milestone milestone--gift';

        if (shippingMet) {
          shippingMilestone.classList.add('milestone--complete');
        } else {
          shippingMilestone.classList.add('milestone--active');
        }

        if (giftMet) {
          giftMilestone.classList.add('milestone--complete');
          progressContainer.classList.add('combined-threshold-progress--success');
        } else if (shippingMet) {
          giftMilestone.classList.add('milestone--active');
          progressContainer.classList.remove('combined-threshold-progress--success');
        } else {
          progressContainer.classList.remove('combined-threshold-progress--success');
        }

        // Update progress bar fill
        progressFill.style.width = `${progressPercent}%`;

        // Update text message
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: cart.currency || 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });

        let messageHTML = '';

        if (giftMet) {
          // Both milestones achieved
          messageHTML = '🎉 You\'ve unlocked Free Shipping and a Free Gift!';
        } else if (shippingMet) {
          // Shipping met, working toward gift
          const remainingToGift = GIFT_THRESHOLD - totalDollars;
          messageHTML = `Add <span class="price"><bdi>${formatter.format(remainingToGift)}</bdi></span> to get a Free Gift!`;
        } else {
          // Working toward shipping
          const remainingToShipping = SHIPPING_THRESHOLD - totalDollars;
          messageHTML = `Add <span class="price"><bdi>${formatter.format(remainingToShipping)}</bdi></span> to get Free Shipping!`;
        }

        textSpan.innerHTML = messageHTML;
        progressContainer.style.display = 'block';

        console.log('[CombinedProgress] Updated:', {
          total: totalDollars,
          progress: progressPercent,
          shippingMet,
          giftMet,
          message: textSpan.textContent
        });
      })
      .catch(err => {
        console.error('[CombinedProgress] Error fetching cart:', err);
        progressContainer.style.display = 'none';
      });
  };

  // Update progress bar when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[CombinedProgress] DOM loaded, attempting first update');
      updateCombinedProgressBar();
    });
  } else {
    console.log('[CombinedProgress] DOM already loaded, attempting first update');
    updateCombinedProgressBar();
  }

  // Listen for cart updates
  document.addEventListener('cart:updated', () => {
    console.log('[CombinedProgress] Cart updated event');
    setTimeout(updateCombinedProgressBar, 100);
  });

  document.addEventListener('cart:refresh', () => {
    console.log('[CombinedProgress] Cart refresh event');
    setTimeout(updateCombinedProgressBar, 100);
  });

  document.addEventListener('cartdrawer:opened', () => {
    console.log('[CombinedProgress] Cart drawer opened event');
    setTimeout(updateCombinedProgressBar, 300);
  });

  console.log('[CombinedProgress] Event listeners registered');
})();
